var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',_vm._b({attrs:{"dense":"","flat":""}},'v-app-bar',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }